import React from 'react';
const TermsPage = () => {
  return <div className="bg-white" data-id="element-1866">
      <div className="container mx-auto px-4 py-12" data-id="element-1867">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1868">
          Terms & Conditions
        </h1>
        <p className="mb-6" data-id="element-1869">
          <span className="text-burgundy-600" data-id="element-1870">N</span>orthampton{' '}
          <span className="text-burgundy-600" data-id="element-1871">D</span>riving{' '}
          <span className="text-burgundy-600" data-id="element-1872">S</span>chool – Learner Driver
          Terms & Conditions
        </p>
        <p className="mb-6" data-id="element-1873">
          By booking or attending lessons with Northampton Driving School, you
          agree to the following terms:
        </p>
        <section className="mb-8" data-id="element-1874">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1875">
            1. Eligibility
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1876">
            <li data-id="element-1877">
              You must hold a valid UK provisional or full driving licence
              recognised in the UK.
            </li>
            <li data-id="element-1878">
              You must show your licence to your instructor at your first lesson
              and whenever asked.
            </li>
            <li data-id="element-1879">
              Any penalty points, endorsements, or medical restrictions must be
              declared.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1880">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1881">
            2. Bookings & Payments
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1882">
            <li data-id="element-1883">
              Lessons must be booked through the school or directly with your
              instructor.
            </li>
            <li data-id="element-1884">
              Payment is required in advance to confirm bookings (individual
              lessons or block bookings).
            </li>
            <li data-id="element-1885">
              Block booking discounts apply only when full payment is made in
              advance.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1886">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1887">
            3. Attendance
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1888">
            <li data-id="element-1889">
              Your instructor will wait at the agreed pick-up point for up to 15
              minutes. If you do not attend, the lesson will be charged in full.
            </li>
            <li data-id="element-1890">All pick-up and drop-off points must be pre-agreed.</li>
            <li data-id="element-1891">
              If using your own car, it must be roadworthy, taxed, MOT'd, and
              insured for learner use. Proof of insurance must be shown each
              lesson.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1892">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1893">
            4. Lesson Conduct
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1894">
            <li data-id="element-1895">
              Pupils must follow the instructor's instructions at all times.
            </li>
            <li data-id="element-1896">
              Aggressive, unsafe, or abusive behaviour will result in immediate
              termination of lessons without refund.
            </li>
            <li data-id="element-1897">
              Pupils must wear suitable footwear (no flip-flops, high heels, or
              unsafe shoes).
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1898">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1899">
            5. Fitness to Drive
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1900">
            <li data-id="element-1901">
              You must not be under the influence of alcohol, drugs, or
              medication that affects driving.
            </li>
            <li data-id="element-1902">
              Lessons will be stopped if your instructor deems you unfit to
              drive, and the full lesson fee will still apply.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1903">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1904">
            6. Driving Tests
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1905">
            <li data-id="element-1906">
              Instructors will only take pupils to a test if they are judged
              "test ready".
            </li>
            <li data-id="element-1907">
              Use of the tuition car for a DVSA driving test is at the
              instructor's discretion.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1908">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1909">
            7. Liability
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1910">
            <li data-id="element-1911">Our vehicles are insured and maintained to a safe standard.</li>
            <li data-id="element-1912">
              Northampton Driving School is not liable for DVSA test
              cancellations, delays, fines, or penalties incurred by pupils.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1913">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1914">
            8. Prices & Changes
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1915">
            <li data-id="element-1916">
              Prices may change at any time, but prior notice will be given
              where possible.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1917">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1918">
            9. Complaints
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1919">
            <li data-id="element-1920">
              Please first raise any concerns directly with your instructor.
            </li>
            <li data-id="element-1921">
              If unresolved, email info@northamptondrivingschool.co.uk. We aim
              to reply within 14 days.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1922">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1923">
            10. Governing Law
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1924">
            <li data-id="element-1925">These Terms are governed by the laws of England and Wales.</li>
          </ul>
        </section>
      </div>
    </div>;
};
export default TermsPage;